export const getApiUrl = ({
  path,
  searchParams = {},
}: {
  path: string;
  searchParams?: Record<string, string | number | Array<string | number>>;
}) => {
  const baseUrl = process?.env?.API_BASE_URL || "/api";

  const queries = Object.entries(searchParams).reduce(
    (result, [key, value]) => {
      if (value) {
        result.push(`${key}=${value}`);
      }
      return result;
    },
    [] as string[],
  );

  const queryParams = queries.join("&");

  return `${baseUrl}${path}${queryParams ? `?${queryParams}` : ""}`;
};
